import {Header} from '../components/Header';

export function Home(): JSX.Element {
  return (
    <div className='relative'>
      <Header/> 
    </div>
  )
};


